export const COLORS = {
    dark: '#1b365d',
    light: '#f2c75c',
    lightDarker: '#f27c5c',
    gray: '#d0d3d4',
    black: '#000',
    white: '#fff'

}